<template>
  <vue-content-loading :height="$vuetify.breakpoint.xsOnly ? 370 : 200" :width="300">
    <rect
      :x="$vuetify.breakpoint.xsOnly ? 115 : 0"
      :y="$vuetify.breakpoint.xsOnly ? 30 : 0"
      :height="$vuetify.breakpoint.xsOnly ? 70 : 40"
      :width="$vuetify.breakpoint.xsOnly ? 70 : 40" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 75 : 45"
      :y="$vuetify.breakpoint.xsOnly ? 115 : 15"
      :rx="5"
      :ry="5"
      :height="14"
      :width="150" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 20 : 15"
      :y="$vuetify.breakpoint.xsOnly ? 150 : 45"
      :height="40"
      :width="$vuetify.breakpoint.xsOnly ? 260 : 270" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 20 : 15"
      :y="$vuetify.breakpoint.xsOnly ? 200 : 90"
      :height="75"
      :width="$vuetify.breakpoint.xsOnly ? 260 : 180" />

    <rect
      :x="$vuetify.breakpoint.xsOnly ? 20 : 200"
      :y="$vuetify.breakpoint.xsOnly ? 280 : 90"
      :height="75"
      :width="$vuetify.breakpoint.xsOnly ? 260 : 85" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
};
</script>
